import { useState, type FormEvent } from 'react';
import { useSession } from '@/app/session';
import { Button, Field, TextInput, Banner } from '@/components/ui';
import { toAppError } from '@/data/errors';

export function LoginPage() {
  const { signIn, signUp } = useSession();
  const [mode, setMode] = useState<'in' | 'up'>('in');
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [info, setInfo] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    setInfo(null);
    try {
      if (mode === 'in') {
        await signIn(email, password);
      } else {
        await signUp(email, password, fullName);
        setInfo('Conta criada. Entre com suas credenciais.');
        setMode('in');
      }
    } catch (err) {
      setError(toAppError(err).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth">
      <form className="auth__card" onSubmit={onSubmit}>
        <div className="auth__brand">
          <span className="brand__mark" aria-hidden>
            NR
          </span>
          <span>Gestão NR-12 / NR-10</span>
        </div>
        <p className="auth__legend">
          {mode === 'in' ? 'Entre para continuar.' : 'Crie sua conta.'}
        </p>

        {error && <Banner kind="danger">{error}</Banner>}
        {info && <Banner kind="info">{info}</Banner>}

        {mode === 'up' && (
          <Field label="Nome completo" required>
            {(id) => (
              <TextInput
                id={id}
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                autoComplete="name"
                required
              />
            )}
          </Field>
        )}

        <Field label="E-mail" required>
          {(id) => (
            <TextInput
              id={id}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          )}
        </Field>

        <Field label="Senha" required hint={mode === 'up' ? 'Mínimo de 8 caracteres.' : undefined}>
          {(id) => (
            <TextInput
              id={id}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete={mode === 'in' ? 'current-password' : 'new-password'}
              minLength={8}
              required
            />
          )}
        </Field>

        <Button type="submit" variant="primary" loading={busy}>
          {mode === 'in' ? 'Entrar' : 'Criar conta'}
        </Button>

        <Button
          variant="ghost"
          size="sm"
          onClick={() => {
            setMode(mode === 'in' ? 'up' : 'in');
            setError(null);
          }}
        >
          {mode === 'in' ? 'Não tenho conta' : 'Já tenho conta'}
        </Button>
      </form>
    </div>
  );
}
